function MetricCardSkeleton() {
  return (
    <div className="bg-sys-brand-surface-container p-4 rounded-xl">
      <div className="animate-pulse h-4 w-24 mb-2 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
      <div className="animate-pulse h-8 w-8 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
    </div>
  );
}

export default function ApplicantPageSkeleton() {
  return (
    <div className="flex flex-col gap-3">
      {/* Metrics Grid */}
      <div className="grid gap-3 grid-cols-2 md:grid-cols-6 lg:grid-cols-6 items-start">
        {Array.from({ length: 8 }).map((_, index) => (
          <MetricCardSkeleton key={index} />
        ))}
      </div>

      {/* Section Title */}
      <div className="px-4 pt-8 pb-6">
        <div className="animate-pulse h-6 w-32 mb-2 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        <div className="animate-pulse h-4 w-64 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
      </div>

      {/* Table */}
      <div className="shadow-web-1 rounded-2xl overflow-hidden">
        {/* Table Header */}
        <div className="bg-sys-brand-surface-container px-4 py-3">
          <div className="grid grid-cols-9 gap-4">
            {Array.from({ length: 8 }).map((_, index) => (
              <div
                key={index}
                className="animate-pulse h-5 col-span-1 rounded-full bg-gradient-to-r from-gray-200 to-gray-50"
              />
            ))}
            <div className="col-span-1" />
          </div>
        </div>

        {/* Table Rows */}
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="px-4 py-3 border-t">
            <div className="grid grid-cols-9 gap-4 items-center">
              <div className="col-span-1">
                <div className="flex items-center gap-3">
                  <div className="animate-pulse h-10 w-10 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                  <div>
                    <div className="animate-pulse h-4 w-24 mb-1 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                    <div className="animate-pulse h-3 w-16 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                  </div>
                </div>
              </div>
              {Array.from({ length: 7 }).map((_, colIndex) => (
                <div
                  key={colIndex}
                  className="animate-pulse h-4 col-span-1 rounded-full bg-gradient-to-r from-gray-200 to-gray-50"
                />
              ))}
              <div className="flex items-center gap-2 justify-end col-span-1">
                <div className="animate-pulse h-8 w-8 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
                <div className="animate-pulse h-8 w-8 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
